import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AutoComplete from './AutoComplete';
import { SearchIconWrapper } from './styled';

const SearchField = ({
  redirectToAdvisorSearch,
  setSearchState,
  redirectToSearch,
  setSearchVal
}: {
  redirectToAdvisorSearch: (_option: AutoCompleteOptionType) => void;
  setSearchState: React.Dispatch<React.SetStateAction<boolean>>;
  redirectToSearch: (_str: string) => void;
  setSearchVal: React.Dispatch<React.SetStateAction<string>>;
}) => (
  <Box
    className="search-container"
    sx={{
      width: { xs: '100%', sm: '101%', md: '422px' },
      height: '32px',
      background: 'rgba(255, 255, 255, 1)',
      zIndex: 1,
      left: { xs: '0', sm: '0', md: '-385px' },
      borderRadius: '100px',
      marginTop: { xs: '13px', md: 'auto' },
      marginLeft: { xs: '4px', sm: '-2px', md: 'auto' }
    }}>
    <AutoComplete
      onOptionSelection={redirectToAdvisorSearch}
      onCloseSelection={() => setSearchState(false)}
      onSearchSelection={redirectToSearch}
      updateSearchVal={setSearchVal}
    />
  </Box>
);

function SearchAdvisors(): JSX.Element {
  const [isShowSearchField, setSearchState] = useState<boolean>(false);
  const [searchVal, setSearchVal] = useState<string>('');

  const redirectToSearch = (str: string): void => {
    const searchStr = str || '*';
    window.location.href = `/search?st=${searchStr}`;
  };

  const redirectToAdvisorSearch = (
    option: AutoCompleteOptionType | string
  ): void => {
    if (typeof option === 'string') redirectToSearch(option);
    else if (option.listingId)
      window.location.href = `/listingdetails?sid=${option.listingId}&callwebtrack=82&chatwebtrack=135`;
    else redirectToSearch(option.label);
  };

  const handleSearchIconClick = (): void => {
    if (isShowSearchField) {
      redirectToSearch(searchVal);
    } else {
      setSearchState(true);
    }
  };

  return (
    <Box
      sx={{
        ml: {
          xs: isShowSearchField ? '35px' : '15px',
          sm: '15px',
          md: '15px'
        },
        position: {
          xs: isShowSearchField ? 'absolute' : 'static',
          sm: isShowSearchField ? 'absolute' : 'static',
          md: isShowSearchField ? 'relative' : 'relative'
        },
        left: '5px',
        right: {
          xs: '10px',
          sm: '20px'
        },
        marginTop: {
          xs: isShowSearchField ? '-16px' : '0',
          sm: isShowSearchField ? '-16px' : '0',
          md: isShowSearchField ? '-30px' : '0'
        },
        display: {
          xs: 'inline-block',
          sm: 'inline-block',
          md: 'inherit'
        },
        zIndex: 2
      }}>
      {isShowSearchField && (
        <SearchField
          redirectToAdvisorSearch={redirectToAdvisorSearch}
          setSearchState={setSearchState}
          redirectToSearch={redirectToSearch}
          setSearchVal={setSearchVal}
        />
      )}
      <SearchIconWrapper isShowSearchField={isShowSearchField}>
        <Button
          className="btn-search-icon"
          variant="contained"
          aria-label="Search Advisors"
          onClick={handleSearchIconClick}
          onMouseDown={handleSearchIconClick}>
          <SearchIcon fontSize="small" />
        </Button>
      </SearchIconWrapper>
    </Box>
  );
}

export default SearchAdvisors;
